import { CellText } from "components/Omnisearch/helpComponents/CellText";
import { SubmissionEncampStatus, SubmissionStatus } from "generated-graphql/graphql";
import { STATUS_LABELS } from "utils/submissionStatusLabels";

type SubmissionStatusCellProps = {
  status?: SubmissionStatus | string | null;
  encampStatus?: SubmissionEncampStatus | string | null;
  isStaff?: boolean;
};

function isInProgressStatus(value: SubmissionStatus | string): boolean {
  return value === SubmissionStatus.InProgress || value === "IN_PROGRESS";
}

function isRejectedEncampStatus(
  value: SubmissionEncampStatus | string | null | undefined
): boolean {
  if (value === null || value === undefined) {
    return false;
  }
  return value === SubmissionEncampStatus.Rejected || value === "REJECTED";
}

export function SubmissionStatusCell({ status, encampStatus, isStaff }: SubmissionStatusCellProps) {
  let statusValue: SubmissionStatus | string = SubmissionStatus.NotStarted;
  if (typeof status === "string") {
    if (status.trim()) {
      statusValue = status;
    }
  } else if (status) {
    statusValue = status;
  }

  const showSentBack =
    isStaff && isInProgressStatus(statusValue) && isRejectedEncampStatus(encampStatus);

  const label = showSentBack
    ? "Sent Back for Edits"
    : (STATUS_LABELS[statusValue] ?? String(statusValue));

  return (
    <CellText variant="body2" noWrap sx={showSentBack ? { color: "#e65100" } : undefined}>
      {label}
    </CellText>
  );
}
